import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='updateCollectedData(collectableData: AchUserDetailsCollectableData)' mdxType="Item">
      <p>{`Update component with collected data by passing implementations of sealed interface.
This method can be called at any point, even if you have only partially collected data.
To validate the partially collected data, you can refer to the
`}<a parentName="p" {...{
          "href": "/docs/sdk/android/2.x.x/primerHeadlessUniversalCheckout/ach/achProvide#common-api-and-available-components-supported-types.StripeAchUserDetailsComponent-api.componentValidationStatus:-FlowlessPrimerValidationStatuslessAchUserDetailsCollectableDatagreatergreater"
        }}>{`componentValidationStatus`}</a>{`
and receive the validation status when it's updated.`}</p>
      <Group summary='sealed interface AchUserDetailsCollectableData' mdxType="Group">
	<Item title='FirstName' mdxType="Item">
		A data class representing the customer's first name.
		<Group summary='Properties' open mdxType="Group">
			<Item title='value' subtitle='String' mdxType="Item">
				The customer's first name.			
			</Item>
		</Group>
	</Item>
	<Item title='LastName' mdxType="Item">
		A data class representing the customer's last name.
		<Group summary='Properties' open mdxType="Group">
			<Item title='value' subtitle='String' mdxType="Item">
				The customer's last name.
			</Item>
		</Group>
	</Item>
	<Item title='EmailAddress' mdxType="Item">
		A data class representing the customer's email address.
		<Group summary='Properties' open mdxType="Group">
			<Item title='value' subtitle='String' mdxType="Item">
				The customer's email address.		
			</Item>
		</Group>
	</Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      